import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      await login(formData.username, formData.password);
      navigate('/dashboard');
    } catch (error) {
      setError('Failed to log in. Please check your credentials.');
      console.error('Login error:', error);
    }
    
    setLoading(false);
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6} lg={4}>
          <Card>
            <Card.Body>
              <h2 className="text-center mb-4">Login</h2>
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                
                <Button 
                  disabled={loading} 
                  className="w-100" 
                  type="submit"
                  variant="primary"
                >
                  {loading ? 'Logging in...' : 'Login'}
                </Button>
              </Form>

              <div className="text-center my-3">
                <span className="text-muted">or</span>
              </div>

              <div className="d-grid mb-2">
                <Button 
                  variant="outline-danger" 
                  className="w-100"
                  onClick={() => window.location.href = '/oauth2/authorization/google'}
                >
                  <i className="fab fa-google me-2"></i>
                  Continue with Google
                </Button>
              </div>

              <div className="d-grid mb-3">
                <Button 
                  variant="outline-primary" 
                  className="w-100"
                  onClick={() => window.location.href = '/oauth2/authorization/facebook'}
                >
                  <i className="fab fa-facebook-f me-2"></i>
                  Continue with Facebook
                </Button>
              </div>
              
              <div className="text-center mt-3">
                <p>
                  <Link to="/forgot-password">Forgot your password?</Link>
                </p>
                <p>
                  Don't have an account? <Link to="/register">Sign up</Link>
                </p>
              </div>
              

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;